import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import _, { trim } from 'lodash';
import { get, isEmpty, isEqual } from 'lodash';
import { getReSignInDataAction, logoutAction, dispatchPreSignInData, getAddUnitListAction, supportAction, getUserProfileDetailsAction, postUserProfileDetailsAction, getTenantAccountAccessAction, getDefaultPageAccess } from '../../actions';
import routes from '../../routes';
import Table from '../../components/CustomTable';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import Textarea from '../../components/FormElements/Textarea';
import ToastModal from "../../components/ToastModal";
import Toastify from "../../components/Toast";
import logo from '../../assets/images/infomo.png';
// import avatarImg from '../../assets/theme/img/avatars/1.png';
import './Header.scss';
import { encryptDataWithBlowfish, isApiCallSuccess, isTenantAgency, checkConnectionManagementAccess } from '../../selectors';
import { handleError, handleFieldError } from '../../utils/form-validation';
import beki from '../../assets/images/bekiLogo.png';
import { defaultPlatformConfig } from '../../constants/configuration';
import { Switch, message } from 'antd';
import CryptoJS from 'crypto-js';
import { ROUTE } from '../../constants/route';
import { MODULE_PERMISSIONS, PERMISSION } from '../../constants/permission';
import { checkPermission } from '../../utils/route-auth';


const TenantDropDown = asyncRoute(() => import('../elements/DropDown/TenantDropDown'));
// const Card = asyncRoute(() => import('../../../components/Card'));
const Tabs = asyncRoute(() => import('../../components/Tabs'));
const Modal = asyncRoute(() => import('../../components/Modal'));
const Input = asyncRoute(() => import('../../components/FormElements/Input'))
const HierarchyChart = asyncRoute(() => import('../../components/HierarchyChart'));


const formFields = {
    name: {
        key: 'name',
        type: 'text',
        label: 'Name',
        required: true,
        placeholder: 'Enter Name',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Name </div>',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
    },
    email: {
        key: 'email',
        type: 'text',
        label: 'Email',
        placeholder: 'Enter Email',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        maxLengthMessage: 'maximum 100 characters allowed.',
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/
    },
    contact: {
        key: 'contact',
        type: 'number',
        label: 'Contact Number',
        required: true,
        placeholder: 'Enter Contact Number',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Tenant Name </div>',
        pattern: /^\d{7,14}(?:,\d{7,14})*$/,
        patternMessage: 'Minimum 7 and Maximum 14 Digit allowed'
    },
    message: {
        key: 'message',
        type: 'text',
        label: 'Message',
        required: true,
        requiredMessage: 'This field is required.',
        placeholder: 'Enter Message',
        displayLayout: 'col-md-12',
        tooltip: '<div> Address1 </div>',
    },

};

const userProfileFormFields = {
    name: {
        key: 'name',
        type: 'text',
        // label: 'Name',
        required: true,
        placeholder: 'Enter Name',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Name </div>',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
    },
    email: {
        key: 'email',
        type: 'text',
        // label: 'Email',
        placeholder: 'Enter Email',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        maxLengthMessage: 'maximum 100 characters allowed.',
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/,
        patternMessage: 'Please enter a valid email'
    },
    otp: {
        key: 'otp',
        type: 'number',
        // label: 'OTP',
        required: true,
        placeholder: 'Enter OTP',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> OTP </div>',
        // pattern: /^\d{7,14}(?:,\d{7,14})*$/,
        // patternMessage: 'Minimum 7 and Maximum 14 Digit allowed'
    },
};

const changePasswordFormFields = {
    oldPassword: {
        key: 'oldPassword',
        type: 'password',
        label: 'Enter Old Password',
        required: true,
        placeholder: 'Password',
        requiredMessage: 'Password is required.',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: `Your password must meet the following criteria:`,
        // patternMessage: 'Password contain at least five character two digit and one capital character.',
        // maxLength: 5,
        // maxLengthMessage: 'maximum 5 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-12'
    },
    password: {
        key: 'password',
        type: 'password',
        label: 'Enter New Password',
        required: true,
        placeholder: 'Password',
        requiredMessage: 'Password is required.',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: `Your password must meet the following criteria:`,
        // patternMessage: 'Password contain at least five character two digit and one capital character.',
        // maxLength: 5,
        // maxLengthMessage: 'maximum 5 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-12'
    },
    confirmPw: {
        key: 'confirmPw',
        type: 'password',
        label: 'Confirm New Password',
        required: true,
        placeholder: 'Confirm New Password',
        requiredMessage: 'Confirm new password is required',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: 'Your password must meet the following criteria:',
        // patternMessage: 'The Password Should Contain Six Letters Including One Capital Letter and Two Digits',
        // maxLength: 10,
        // maxLengthMessage: 'maximum 10 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-6',
        customError: false,
        customErrorMessage: "Password does not match"
    },

};

class Header extends Component {
    constructor(props) {
        super(props);
        this.orgChartRef = React.createRef(); // Initialize the ref
        this.state = {
            showLogout: false,
            openHelpModal: false,
            openUserProfile: false,
            openChangePassword: false,
            openAccountAccess: false,
            form: {},
            touched: {},
            errors: {},
            submited: false,
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            isAgency: isTenantAgency(props.tenantId),
            logoImage: '',
            displayMode: 'table', // Default to table mode
            uploadedImage: null,
            userProfileDetails: {
                name: '',
                email: '',
                otp: ''
            },
            base64Image: '',
            tempBase64Image: null,
            editName: false,
            editEmail: false,
            otpVisible: false,  // To control OTP field visibility
            otpStartTime: null, // To track OTP start time
            otpEndTime: null,   // To track OTP end time
            timer: null,        // Timer reference for countdown
            remainingTime: 0,   // Remaining time for OTP,
            accountAccessData: [],
            changePasswordForm: {},
            changePasswordTouched: {},
            changePasswordErrors: {},
            changePasswordSubmited: false,

        };
        this.handleTenantChange = this.handleTenantChange.bind(this);
        this.handleProfileClick = this.handleProfileClick.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleEditToggle = this.handleEditToggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        const { platformConfiguration } = this.props;
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        } else {
            logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        }
        this.setState({ logoImage: logoImageUrl });
    }

    componentWillReceiveProps(nextProps) {
        const { platformConfiguration, tenantId } = this.props;
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        } else {
            logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        }
        this.setState({ logoImage: logoImageUrl, isAgency: isTenantAgency(tenantId) });
    }
    changePasswordDisabled() {
        const { changePasswordForm } = this.state;
        let { valid } = handleError(changePasswordForm, changePasswordFormFields);
        return (isEmpty(changePasswordForm.password) || isEmpty(changePasswordForm.confirmPw) || !valid);
    }

    componentDidMount() {
        // this.checkUserProfileInStorage();
        this.userProfileDetails();
    }

    // async checkUserProfileInStorage() {
    //     const userProfileStorageData = sessionStorage.getItem('userProfileDetails');
    //     if (userProfileStorageData) {
    //         // If data exists, parse and set it in the component's state
    //         const userProfileDetails = JSON.parse(userProfileStorageData);
    //         this.setState({ userProfileDetails, base64Image: userProfileDetails.profilePic });
    //     } else {
    //         // If no data, fetch it from the API
    //         this.userProfileDetails();
    //     }
    // }

    userProfileDetails = async () => {
        try {
            const { tenantId, userId, getUserProfileDetailsAction } = this.props;
            const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            const preSignInState = JSON.parse(localStorage.getItem('PreSignInState'));
            const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            const { authToken } = AuthData;
            const params = {
                getProfile: preSignInData.userId,
            };
            const { responseCode: { status = "", msg }, responseList } = await getUserProfileDetailsAction({
                tenantId: preSignInState.tenantId,
                authToken,
                userId: preSignInData.userId,
                params,
            });
            if (isApiCallSuccess(status)) {
                // sessionStorage.setItem("userProfileDetails", JSON.stringify(responseList[0]));
                this.setState({ userProfileDetails: responseList[0], base64Image: responseList[0].profilePic });
            }
            else {
                message.error(msg)
            }
        } catch (err) {
            console.error("Error fetching user profile:", err);
        }
    };


    handleTenantChange(event) {
        localStorage.setItem('isSigningIn', 1);
        sessionStorage.setItem('advertiserData', JSON.stringify({}));
        // console.log(event.target.name,"event")
        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        const { responseList, userId } = preSignInData;
        const AuthData = JSON.parse(localStorage.getItem('AuthData'));
        const PreSignInState = JSON.parse(localStorage.getItem('PreSignInState'));
        const { authToken } = AuthData;
        const { value } = event.target;

        if (value) {
            // const id = responseList.find(id => id.tenantName == value ||
            //     `${id.tenantName} (${id.parentTenantName})` == value ||
            //     `${id.tenantName.replace(/\s\s+/g, ' ')} (${id.parentTenantName.replace(/\s\s+/g, ' ')})` == value.replace(/\s\s+/g, ' ') ||
            //     id.tenantName.replace(/\s\s+/g, ' ') == value.replace(/\s\s+/g, ' ')
            // );
            const id = responseList.find(item => item.tenantId == value)
            const tenantId = id.tenantId;
            localStorage.removeItem("editId");

            const { getReSignInDataAction, preSignInState, dispatchPreSignInData, getDefaultPageAccess, history, match, history: { location: { pathname = '' } } } = this.props;

            if (!isEmpty(preSignInState)) {

                dispatchPreSignInData({ ...preSignInState, tenantId }).then(async () => {
                    let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                    let { responseCode: { status = '' }, authToken = '' } = await getReSignInDataAction(data, AuthData.authToken);
                    // let { responseCode: { status = '' }, authToken = '' } = await getReSignInDataAction({ ...preSignInState, tenantId }, authToken);
                    if (status === 'Success' && authToken) {

                        const { responseCode: { status: defaultPageStatus }, responseObj: defaultPageResponse } = await getDefaultPageAccess({ tenantId, authToken, userId });
                        console.log("defaultPageStatus", defaultPageStatus)
                        console.log("defaultPageResponse", defaultPageResponse)
                        console.log("checkPermission({ permissions: [PERMISSION.DASHBOARD.VIEW] })", checkPermission({ permissions: [PERMISSION.DASHBOARD.DASHBOARD.VIEW] }))
                        // debugger;
                        localStorage.setItem('isSigningIn', 0);
                        // if (pathname.includes('atd-home')) {
                        // if (defaultPageResponse.defaultPageName) {
                        //     switch (defaultPageResponse.defaultPageName) {
                        //         case 'ATD Dashboard':
                        //             history.push(`${match.path}/${routes.containers.dashboard}`);
                        //             break;
                        //         case 'ATD Campaign':
                        //             history.push(`${match.path}/${routes.containers.campaignList}`);
                        //             break;
                        //         case 'ATD Creative':
                        //             history.push(`${match.path}/${routes.containers.creative}`);
                        //             break;
                        //         case 'ATD Admin':
                        //             // history.push(routes.containers.admin);
                        //             let getUserPermissionList = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                        //             let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
                        //             if (admin && ROUTE[admin]) {
                        //                 history.push(ROUTE[admin]);
                        //                 // defaultRoute.admin = ROUTE[admin];
                        //                 // if (!defaultMainRoute) {
                        //                 //     defaultMainRoute = ROUTE[admin];
                        //                 // }
                        //             }
                        //             break;
                        //         case 'ATD Payment Subscription':
                        //             let userPermissionListData = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                        //             let payment = MODULE_PERMISSIONS.PAYMENT.find(a => userPermissionListData.indexOf(a) > -1);

                        //             console.log("QWERTY", payment, ROUTE[payment]);
                        //             if (payment && ROUTE[payment]) {
                        //                 history.push(`${match.path}/${ROUTE[payment]}`);
                        //             }
                        //             break;
                        //         case 'ATD Fee Setting':
                        //             history.push(`${match.path}/${routes.containers.feeSettings}`);
                        //             break;
                        //         case 'ATD Optimiser':
                        //             history.push(`${match.path}/${routes.containers.optimizer}`);
                        //             break;
                        //         default:
                        //             history.push(`${match.path}/${routes.containers.dashboard}`);
                        //     }
                        //     // }
                        // }

                        // else if (checkPermission({ permissions: [PERMISSION.DASHBOARD.DASHBOARD.VIEW] })) {
                        //     history.push(`${match.path}/${routes.containers.dashboard}`);
                        // }
                        // else if (checkPermission({ permissions: [PERMISSION.CREATIVE.CREATIVE.VIEW] })) {
                        //     history.push(`${match.path}/${routes.containers.creative}`);
                        // }
                        // else if (checkPermission({ permissions: [PERMISSION.OPTIMIZER.OPTIMIZER.VIEW] })) {
                        //     history.push(`${match.path}/${routes.containers.optimizer}`);
                        // }
                        // else if (checkPermission({ permissions: [PERMISSION.CAMPAIGN.CAMPAIGN.VIEW] })) {
                        //     history.push(`${match.path}/${routes.containers.campaignList}`);
                        // }
                        // else if (checkPermission({ permissions: [PERMISSION.FEESETTING.FEESETTING.VIEW] })) {
                        //     history.push(`${match.path}/${routes.containers.feeSettings}`);
                        // }
                        // else if (checkPermission({ permissions: [PERMISSION.ADMIN.VIEW] })) {
                        //     let getUserPermissionList = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                        //     let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
                        //     if (admin && ROUTE[admin]) {
                        //         history.push(ROUTE[admin]);
                        //     }
                        // }
                        // else if (checkConnectionManagementAccess() && checkPermission({ permissions: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW] })) {
                        //     history.push(routes.containers.admin + '/' + routes.admin.connection.name);
                        // }

                        // else if (pathname.includes('atd-home')) {
                        //     history.push(`${match.path}/${routes.containers.dashboard}`);
                        // }
                        // else {
                        //     setTimeout(() => {
                        //         window.location.reload();
                        //     }, 500);
                        // }




                        this.redirectBasedOnDefaultPage(defaultPageResponse.defaultPageName);

                        if (defaultPageResponse.defaultPageName) return;

                        if (this.checkAndRedirectPermission(PERMISSION.DASHBOARD.DASHBOARD.VIEW, routes.containers.dashboard)) return;
                        if (this.checkAndRedirectPermission(PERMISSION.CREATIVE.CREATIVE.VIEW, routes.containers.creative)) return;
                        if (this.checkAndRedirectPermission(PERMISSION.OPTIMIZER.OPTIMIZER.VIEW, routes.containers.optimizer)) return;
                        if (this.checkAndRedirectPermission(PERMISSION.CAMPAIGN.CAMPAIGN.VIEW, routes.containers.campaignList)) return;
                        if (this.checkAndRedirectPermission(PERMISSION.FEESETTING.FEESETTING.VIEW, routes.containers.feeSettings)) return;
                        if (this.checkAndRedirectPermission(PERMISSION.ADMIN.VIEW, this.getAdminRoute())) return;
                        if (this.checkAndRedirectPermission(PERMISSION.AUDIENCE.VIEW, routes.containers.audience)) return;
                        if (this.checkConnectionManagementAccess() && this.checkAndRedirectPermission(PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW, `${routes.containers.admin}/${routes.admin.connection.name}`)) return;
                    }
                }).catch((e) => {
                    console.log(e);
                    localStorage.setItem('isSigningIn', 0);
                });
            } else {
                dispatchPreSignInData({ ...PreSignInState, tenantId }).then(async () => {
                    let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                    getReSignInDataAction(data, authToken);
                    // getReSignInDataAction({ ...PreSignInState, tenantId }, authToken);
                });
            }
        }
    }


    redirectBasedOnDefaultPage(defaultPageName) {
        const { history, match } = this.props;
        switch (defaultPageName) {
            case 'ATD Dashboard':
                history.push(`${match.path}/${routes.containers.dashboard}`);
                break;
            case 'ATD Campaign':
                history.push(`${match.path}/${routes.containers.campaignList}`);
                break;
            case 'ATD Creative':
                history.push(`${match.path}/${routes.containers.creative}`);
                break;
            case 'ATD Admin':
                this.redirectToAdmin();
                break;
            case 'ATD Payment Subscription':
                this.redirectToPaymentSubscription();
                break;
            case 'ATD Fee Setting':
                history.push(`${match.path}/${routes.containers.feeSettings}`);
                break;
            case 'ATD Optimiser':
                history.push(`${match.path}/${routes.containers.optimizer}`);
                break;
            default:
                history.push(`${match.path}/${routes.containers.dashboard}`);
        }
    }

    checkAndRedirectPermission(permission, route) {
        const { history, location } = this.props;
        if (checkPermission({ permissions: [permission] })) {
            // debugger;
            if (location.pathname.includes(route)) {
                window.location.reload();
            } else {
                history.push(route);
            }
            return true;
        }
        return false;
    }


    getAdminRoute() {
        let getUserPermissionList = localStorage.getItem('getUserPermissionList') ? JSON.parse(localStorage.getItem('getUserPermissionList')) : [];
        let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
        if (admin && ROUTE[admin]) {
            return ROUTE[admin];
        }
        return routes.containers.admin;
    }

    redirectToAdmin() {
        const { history } = this.props;
        let adminRoute = this.getAdminRoute();
        if (adminRoute) {
            history.push(adminRoute);
        }
    }

    redirectToPaymentSubscription() {
        const { history } = this.props;
        let userPermissionListData = localStorage.getItem('getUserPermissionList') ? JSON.parse(localStorage.getItem('getUserPermissionList')) : [];
        let payment = MODULE_PERMISSIONS.PAYMENT.find(a => userPermissionListData.indexOf(a) > -1);
        // debugger;
        if (payment && ROUTE[payment]) {
            history.push(ROUTE[payment]);
        }
    }



    handleProfileClick() {
        const { showLogout } = this.state;
        this.setState({
            showLogout: !showLogout,
        });
    }

    handleLogout() {
        const AuthData = JSON.parse(localStorage.getItem('AuthData'));
        const { authToken } = AuthData;
        const { logoutAction, preSignInState, history, match } = this.props;
        // preSignInState.tenantId = preSignInState.tenantId 
        // console.log(this.props,"propsData")

        logoutAction(preSignInState, authToken).then(() => {
            history.push(`${match.path}/${routes.preSignIn}`);
        });
    }

    handleLogoClick = () => {
        const { history, match } = this.props;
        history.push(`${match.path}/${routes.containers.dashboard}`);
    }

    collapseToggle = (e) => {
        e.preventDefault();
        const { toggleSidebar, isCollapse } = this.props;
        window.Helpers.toggleCollapsed();
        toggleSidebar(isCollapse);
    }

    handleChange = (e) => {
        this.setState({ form: { ...this.state["form"], [e.target.name]: e.target.value } })
    }

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };


    // ChangePassword

    handlePasswordChange = (e) => {
        this.setState({ changePasswordForm: { ...this.state["changePasswordForm"], [e.target.name]: e.target.value } })
    }

    handlePasswordCTouch = (e) => {
        let { changePasswordTouched, changePasswordForm, changePasswordErrors } = this.state;
        let { error } = handleFieldError(changePasswordForm[e.target.name], changePasswordFormFields[e.target.name]);
        changePasswordErrors[e.target.name] = error;
        changePasswordTouched[e.target.name] = true;
        this.setState({ changePasswordTouched, changePasswordErrors });
    };


    savePasswordAction = () => {
        const { changePasswordForm } = this.state
        let { changePasswordErrors, valid } = handleError(changePasswordForm, changePasswordFormFields)
        console.log(valid)
        if (valid) {
            console.log(changePasswordForm, "changePasswordForm")
            this.setState({ enableToast: true, confirmationMsg: "Please confirm if you'd like to proceed with this action.", toastMsg: "", toastStatus: "", method: 'contactSupport', });

        } else {

            alert("please first fill all fileds")
        }

    }

    handleSubmit = (e) => {

        const { form } = this.state;
        const { match: { params: { id } } } = this.props;
        let { errors, valid } = handleError(form, formFields);

        if (valid) {

            this.setState({ enableToast: true, confirmationMsg: "Please confirm if you'd like to proceed with this action.", toastMsg: "", toastStatus: "", method: 'contactSupport', contactData: form });

        } else {
            this.setState({ enableToast: true, toastMsg: "Please fill in the required fields ", toastStatus: "Fail" });
            this.setState({ errors: errors, submited: true });
        }
    }

    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        const { method } = this.state;

        this.setState({ enableToast: false }, () => {
            if (method == "contactSupport") {
                this.submitContactForm()
            }
            else if (method == "changePassword") {
                this.handleUpdateProfile("password")
            }
        });
    }

    handleToastStatus = (status) => {
        this.setState({ enableToast: status });
    }

    submitContactForm = async () => {
        const { openHelpModal, form, contactData } = this.state;

        const { supportAction, tenantId, authToken, userId, addTenantAction } = this.props;
        // let addParams = { action: 'update' };
        console.log("form", form);
        const payload =
        {
            "name": form.name,
            "email_id": form.email,
            "mobile_num": form.contact,
            "subject": "Contact Us",
            "message": form.message,
            "isEmail": 1
        }

        const {
            responseCode: { status = "", msg },
            responseList,
        } = (await supportAction({ tenantId, authToken, userId, payload })) || {};
        if (status.toLowerCase() == "success") {
            // this.toast(status, msg, "contactSupport");
            this.setState({ openHelpModal: !openHelpModal, enabletoastify: true, toastifyMsg: msg }, () => {
                setTimeout(() => {
                    this.setState({ enabletoastify: false })
                }, 4000)
            })
        }
    }



    setForm = async () => {
        const { openHelpModal } = this.state;

        this.setState({})
        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));

        this.setState({
            form: {
                ...this.state.form,
                name: preSignInData.username,
                email: preSignInData.userEmail,
                contact: preSignInData.userContact,
            },
            openHelpModal: !openHelpModal
        })

    }

    handleToggle = () => {
        this.setState(
            (prevState) => ({ isAgency: !prevState.isAgency }),
            () => {
                const { preSignInResponseList } = this.props;
                const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
                const { responseList } = preSignInData;
                const { isAgency } = this.state;
                sessionStorage.setItem('advertiserData', JSON.stringify({}));
                // Filter the responseList based on the isAgency flag
                // const filteredList = responseList.filter(item =>
                //     isAgency ? item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" : true
                // );
                // const value = filteredList[0].tenantName;
                // this.handleTenantChange({ target: { value: value } });

                //----------------Stop resignin on toggle----------------
                const tenantId = '';
                // Pass the empty string as tenantId to TenantDropDown
                this.setState({ tenantId: tenantId });

                // auto select on single tenant and swithing tenant type
                if (isAgency) {
                    const filteredList = preSignInResponseList.filter(item => {
                        return item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency"
                    });

                    if (filteredList.length === 1) {
                        this.handleTenantChange({ target: { value: filteredList[0].tenantId } })
                    }
                }
                else {
                    const filteredList = preSignInResponseList.filter(item => {
                        if (item.tenantType === "Platform Manager") {
                            return true;
                        }
                        return !(item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency")
                    });

                    if (filteredList.length === 1) {
                        this.handleTenantChange({ target: { value: filteredList[0].tenantId } })
                    }
                }
            }
        );
    };


    formInitialize = () => {
        // let { changePasswordForm, changePasswordErrors } = initializeForm(changePasswordFormFields);
        // this.setState({changePasswordForm})

        let changePasswordForm = {};
        let changePasswordErrors = {};
        _.each(_.keys(changePasswordFormFields), function (key) {
            changePasswordForm[key] = changePasswordFormFields[key] ? changePasswordFormFields[key].defaultValue || '' : '';
            changePasswordErrors[key] = {};
        });
        // return { form, errors };
        this.setState({ changePasswordForm, changePasswordErrors })
    };

    changePasswordAction = () => {
        this.setState({ openChangePassword: true }, () => {
            this.formInitialize()

        })
    }

    handleAccountAccess = () => {
        this.setState({ openAccountAccess: true }, () => {
            this.getAccountAccess();
        })

    }


    toggleToGraph = () => {
        this.setState({ displayMode: 'graph' }, () => {
            // If switching to graph, scroll the chart to the center
            console.log("orgChartRef", this.orgChartRef)
            if (this.orgChartRef) {
                // this.orgChartRef.scrollToCenter();
            }
        });
    };

    toggleToTable = () => {
        this.setState({ displayMode: 'table' });
    };

    renderContent = () => {
        const { accountAccessData, displayMode } = this.state; // Assuming accPerformanceListData is in component state

        const accountAccessoptions = {
            columns: [
                { id: 1, name: '', label: '', sortable: false, },
                { id: 2, name: 'tenantName', label: 'Account', sortable: false, type: 'string', component: (row) => <div title={row.tenantName}>{row.parentName && row.level != 1 ? `${row.tenantName} (${row.parentName})` : row.tenantName}</div> },
                { id: 3, name: 'roleName', label: 'Role', sortable: false, type: 'string', },
            ],
            keyCol: 'ioNo',
            actionName: 'ACTIONS',
            actions: [
                {
                    type: 'edit',
                    text: '',
                    icon: 'ti ti-pencil color-beki',
                    tooltip: 'Edit',
                    iconType: 'new'
                },
            ],
            recActive: false,
            actionsThead: false,
            sortable: true,
            dateType: true,
            defaultSortParams: {
                sortBy: 'txnDateTime',
                sortOrder: 'desc'
            },
            paging: true,
            defaultPagingParams: {
                pageSize: 10
            }
        };

        // const data = [
        //     {
        //         tenantName: "abc",
        //         tenantId: 1,
        //         roleName: "role",
        //         parentName: "user",
        //         isParent: true,
        //         level: 1,
        //     },
        //     {
        //         tenantName: "def",
        //         tenantId: 2,
        //         roleName: "role",
        //         parentName: "user",
        //         isParent: true,
        //         level: 1,
        //     },
        //     {
        //         tenantName: "ghi",
        //         tenantId: 3,
        //         roleName: "role",
        //         parentName: "abc",
        //         parentId: 1,
        //         isParent: false,
        //         level: 2,
        //     },
        //     {
        //         tenantName: "jkl",
        //         tenantId: 4,
        //         roleName: "role",
        //         parentName: "abc",
        //         parentId: 1,
        //         isParent: false,
        //         level: 2,
        //     },
        //     {
        //         tenantName: "mno",
        //         tenantId: 5,
        //         roleName: "role",
        //         parentName: "def",
        //         parentId: 2,
        //         isParent: false,
        //         level: 2,
        //     },
        // ];

        // Group elements by parent name
        const groupedByParent = accountAccessData.reduce((acc, item) => {
            const parentName = item.parentName;
            if (!acc[parentName]) {
                acc[parentName] = [];
            }
            acc[parentName].push(item);
            return acc;
        }, {});
        // console.log("groupedByParent", groupedByParent)

        // Recursive function to build the tree structure
        const buildTree = (name) => {
            const children = groupedByParent[name] || [];
            // Find the first item in the children that matches the current name to get the roleName
            const currentItem = accountAccessData.find((item) => item.tenantName === name);
            // console.log("currentItem", currentItem)
            const roleName = currentItem ? currentItem.roleName : 'User'; // Handle case where roleName isn't found
            // console.log("roleName", roleName)
            return {
                name: name,
                roleName: roleName, // Add the roleName here
                children: children.map((child) => buildTree(child.tenantName)), // Recursively build children
            };
        };

        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        const { username } = preSignInData;

        const rootName = username;
        // Build the organizational tree
        const orgTree = buildTree(rootName);

        // console.log("orgTree", orgTree)

        if (displayMode === 'table') {
            return <div className=" mb-3 campaign-list-adj table-responsive">
                <Table
                    options={accountAccessoptions}
                    data={accountAccessData}
                />
            </div>

        }
        else if (displayMode === 'graph') {
            // return <HierarchyChart orgTree={orgTree} />
            return <HierarchyChart orgTree={orgTree} ref={(ref) => (this.orgChartRef = ref)} />;

        }


        return null;
    };

    // This method is triggered when a file is uploaded
    handleImageChange(event) {
        const file = event.target.files[0]; // Get the first file
        if (file) {
            this.setState({ uploadedImage: file });
            this.handleImageUpload(file);
        }
    }

    // This method converts the image to Base64 and sets it in the state
    handleImageUpload(file) {
        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                tempBase64Image: reader.result,
            }, () => {
                this.handleUpdateProfile("editImage");
            });
        };

        reader.readAsDataURL(file); // Start reading the file to Base64
    }

    triggerFileInput() {
        document.getElementById('fileInput').click();
    }

    handleEditToggle(field) {
        this.setState((prevState) => ({
            [field]: !prevState[field], // Toggle the edit state for the field
        }));
    }

    handleInputChange(event, fieldName) {
        const { value } = event.target;
        this.setState((prevState) => ({
            userProfileDetails: {
                ...prevState.userProfileDetails,
                [fieldName]: value,
            },
        }));
    }

    handleDetailsTouch = (e) => {
        let { touched, userProfileDetails, errors } = this.state;
        let { error } = handleFieldError(userProfileDetails[e.target.name], userProfileFormFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };


    async handleUpdateProfile(field) {

        try {
            const { tenantId, userId, postUserProfileDetailsAction } = this.props;
            const { userProfileDetails, base64Image, tempBase64Image, changePasswordForm } = this.state;
            const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            const { authToken } = AuthData;
            let newPassword = CryptoJS.MD5(changePasswordForm.password).toString();
            // newPassword = encryptDataWithBlowfish(newPassword, 'string');

            let oldPassword = CryptoJS.MD5(changePasswordForm.oldPassword).toString();
            // oldPassword = encryptDataWithBlowfish(oldPassword, 'string');
            // Create the payload based on the field being updated
            let payload = {};
            if (field == "editEmail") {
                payload.newEmail = userProfileDetails.email;
            } else if (field == "editName") {
                payload.name = userProfileDetails.name;
            } else if (field == "editImage") {
                payload.profilePic = tempBase64Image;
            } else if (field == "otp") {
                payload.newEmail = userProfileDetails.email;
                payload.OTP = userProfileDetails.otp;
            } else if (field == "password") {
                payload.newPassword = newPassword;
                payload.oldPassword = oldPassword;
            }

            const params = {
                updateProfile: preSignInData.userId,
            };

            const {
                responseCode: { status = "", msg }, response
            } = await postUserProfileDetailsAction({ tenantId, authToken, userId: preSignInData.userId, payload, params });

            if (isApiCallSuccess(status)) {
                if (field == "editImage") {
                    this.setState({
                        base64Image: tempBase64Image,
                        tempBase64Image: null,
                    });
                }
                else if (field == "editEmail") {
                    const { startTime, endTime } = response;

                    // Start OTP verification process
                    this.setState({
                        otpVisible: true,
                        otpStartTime: startTime,
                        otpEndTime: endTime,
                        remainingTime: endTime * 1000 - Date.now(), // Calculate remaining time in milliseconds
                    });

                    // Start the timer
                    this.startOtpTimer();
                    message.success(msg)
                }
                else if (field == "otp") {
                    message.success(msg)
                    this.setState({ otpVisible: false, editEmail: false, })
                }
                else if (field == "password") {
                    message.success(msg)
                    this.setState({ openChangePassword: false })
                    this.handleLogout();
                }
                else {
                    message.success(msg)
                    this.handleEditToggle(field)
                }
            }
            else {
                message.error(msg)
                console.error("Failed to update profile:", msg);
                this.setState({
                    tempBase64Image: null, // Clear the temporary image on failure
                });
            }
        } catch (error) {
            console.error("Error updating user profile:", error);
            this.setState({
                tempBase64Image: null, // Clear the temporary image on failure
            });
        }
    }


    startOtpTimer() {
        const interval = setInterval(() => {
            const { otpEndTime } = this.state;
            const remainingTime = otpEndTime * 1000 - Date.now();

            if (remainingTime <= 0) {
                clearInterval(this.state.timer);
                this.setState({ otpVisible: false }); // Hide OTP field when timer expires
            } else {
                this.setState({ remainingTime });
            }
        }, 1000);

        this.setState({ timer: interval });
    }

    // Convert milliseconds to MM:SS format
    formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60); // Whole minutes
        const seconds = totalSeconds % 60; // Remaining seconds
        const formattedMinutes = minutes.toString().padStart(2, '0'); // Ensure 2 digits for minutes
        const formattedSeconds = seconds.toString().padStart(2, '0'); // Ensure 2 digits for seconds
        return `${formattedMinutes}:${formattedSeconds}`;
    };


    async getAccountAccess() {

        try {
            const { tenantId, userId, getTenantAccountAccessAction } = this.props;
            const { userProfileDetails, base64Image, tempBase64Image } = this.state;
            const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            const { authToken } = AuthData;

            const params = {
                tenantHierarchy: preSignInData.userId,
            };

            const {
                responseCode: { status = "", msg }, responseList
            } = await getTenantAccountAccessAction({ tenantId, authToken, userId: preSignInData.userId, params });

            if (isApiCallSuccess(status)) {
                this.setState({ accountAccessData: responseList })
                message.success(msg)
            }
            else {
                message.error(msg)
                console.error("Failed to update profile:", msg);
                this.setState({
                    tempBase64Image: null, // Clear the temporary image on failure
                });
            }
        } catch (error) {
            console.error("Error updating user profile:", error);
            this.setState({
                tempBase64Image: null, // Clear the temporary image on failure
            });
        }
    }


    handleResetSubmit = (e) => {
        e.preventDefault();
        const { changePasswordForm } = this.state;
        let { errors, valid } = handleError(changePasswordForm, changePasswordFormFields);
        const { confirmPw, password } = changePasswordForm;
        if (valid) {
            if (password != confirmPw) {
                // let info = { action: { confirmationMessage: 'Password and confirm password should be same.', type: 'error' } }
                // this.toggleModal(info)
                // this.setState({ enableToast: true, toastMsg: "Password and Confirm Password should be same.", toastStatus: "Fail", method: 'Save' });
                this.setState({ enableToast: true, toastMsg: "Make sure the entered password matches the one you provided above", toastStatus: "Fail", method: 'changePassword' });
                return false;
            } else {
                // this.submitForm()
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", toastMsg: "", toastStatus: "", method: 'changePassword' });

            }
        } else {
            this.setState({ errors: errors, submited: true });
        }
    }

    async submitForm() {
        const { location, changePasswordAction } = this.props;
        const { changePasswordForm } = this.state;
        let search = location.search;
        const params = new URLSearchParams(search);
        const rp = params.get('rp');
        // const authUser = params.get('uid');
        // let password = changePasswordForm.password
        let password = CryptoJS.MD5(changePasswordForm.password).toString();
        password = await encryptDataWithBlowfish(password, 'string');

        const { responseCode: { status = '', msg = '' } } = await postUserProfileDetailsAction({ password, rp })
        // const { responeCode: { status } } = await changePasswordAction({ password, rp, authUser })
        if (status == 'Success') {
            // let successfullyMessage = { action: { confirmationMessage: 'Successfully change password.', type: 'alert' } }
            // this.setState({ confirmationOpen: false, changePasswordForm: {}, errors: {} }, () => {
            //     this.toggleModal(successfullyMessage);
            // })
            this.toast(status, 'Your password has been configured successfully, Please continue to Login.')
            return;
        } else {
            // let info = { action: { confirmationMessage: 'Error occurs', type: 'error' } }
            this.setState({ enableToast: true, toastMsg: "Error occurs", toastStatus: "Fail", method: 'Save' });

            // this.toggleModal(info);
        }
    }

    handleChangePassword = (e) => {
        let { changePasswordTouched, changePasswordForm, changePasswordErrors } = this.state;

        let { value, name } = e.target;
        changePasswordForm[name] = value;
        console.log("value", value)

        // Check if old password and new password are the same
        if (name === 'password' || name === 'oldPassword') {
            const oldPassword = changePasswordForm['oldPassword'];
            const newPassword = changePasswordForm['password'];

            if (oldPassword === newPassword) {
                // Set a custom error flag for password field
                changePasswordFormFields['password'].customError = true;
                changePasswordErrors['password'] = "New password cannot be the same as the old password.";
                message.error("New password cannot be the same as the old password.");
            } else {
                changePasswordFormFields['password'].customError = false;
                changePasswordErrors['password'] = null;
            }
        }

        this.setState({ changePasswordForm }, async () => {
            const isChangePassowordDisabled = this.changePasswordDisabled();
            this.setState({
                isChangePassowordDisabled,
            });
            await this.checkValidationMatchString(name)
            this.handleTouch({ target: { name: name } })
            console.log("changePasswordForm", changePasswordForm)
        });
    }

    checkValidationMatchString = async (name) => {
        const { changePasswordForm } = this.state;
        if (changePasswordForm.password && changePasswordForm.password.length > 0 && changePasswordForm.confirmPw && changePasswordForm.confirmPw.length > 0 && changePasswordForm.password != changePasswordForm.confirmPw) {
            changePasswordFormFields.confirmPw.customError = true;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else if (changePasswordForm.password && changePasswordForm.password.length > 0 && changePasswordForm.confirmPw && changePasswordForm.confirmPw.length > 0 && changePasswordForm.password == changePasswordForm.confirmPw) {
            changePasswordFormFields.confirmPw.customError = false;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else {
            changePasswordFormFields.confirmPw.customError = false
        }
    }

    handleOldPassword = async (e) => {
        // const {changePasswordFormFieldsState} = this.props
        if (changePasswordFormFields.oldPassword.type === 'password') {
            changePasswordFormFields.oldPassword.type = "text"
        } else {
            changePasswordFormFields.oldPassword.type = "password"
        }

        return this.setState(changePasswordFormFields)
    }

    handlePassword = async (e) => {
        // const {changePasswordFormFieldsState} = this.props
        if (changePasswordFormFields.password.type === 'password') {
            changePasswordFormFields.password.type = "text"
        } else {
            changePasswordFormFields.password.type = "password"
        }

        return this.setState(changePasswordFormFields)
    }

    handleConfirmPassword = async (e) => {
        if (changePasswordFormFields.confirmPw.type === 'password') {
            changePasswordFormFields.confirmPw.type = "text"
        } else {
            changePasswordFormFields.confirmPw.type = "password"
        }

        return this.setState(changePasswordFormFields)

    }

    passwordValidation = (propsData) => {

        const { password = '' } = propsData
        console.log("password", password)

        function renderErrorMessage(condition, message) {
            if (!condition) {
                return <p className='error-message' style={{ marginBottom: 0 }}>{message}</p>;
            }
            return null;
        }

        return (
            <div style={{ marginTop: -15 }}>
                {renderErrorMessage(/(?=.*[A-Z])/.test(password), "- Contain at least one uppercase letter (A-Z).")}
                {renderErrorMessage(/(?=(?:.*[a-z]){5,})/.test(password), "- Contain at least five lowercase letters (a-z).")}
                {renderErrorMessage(/.*\d.*\d.*/.test(password), "- Include at least two digits (0-9).")}
                {renderErrorMessage(/^(?=.*@)[a-zA-Z0-9@]+$/.test(password), "- Include at least one special character (@).")}
                {renderErrorMessage(!(password.length < 9), "- Be at least 9 characters long.")}
            </div>
        );
    }

    scrollToCenterHandler = () => {
        if (this.orgChartRef.current) {
            // Check for the method before calling it
            if (typeof this.orgChartRef.current.scrollToCenter === 'function') {
                this.orgChartRef.current.scrollToCenter();
            } else {
                console.warn('scrollToCenter function is not defined');
            }
        }
    }

    render() {
        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        const preSignInState = JSON.parse(localStorage.getItem('PreSignInState'));

        const { responseList, username } = preSignInData;
        const { editEmail, editName, userProfileDetails, logoImage, base64Image, displayMode, isAgency, showLogout, openHelpModal, form, errors, touched, submited, enableToast, toastStatus, toastMsg, confirmationMsg, enabletoastify, toastifyMsg, openAccountAccess, openUserProfile, openChangePassword, changePasswordForm, changePasswordTouched, changePasswordErrors, changePasswordSubmited } = this.state;
        const { userProfileDetailsRedux, preSignInResponseList, tenantId, history: { location: { pathname = '' } } } = this.props;
        const isNameInvalid = errors.name && Object.keys(errors.name).length > 0
        const isEmailInvalid = errors.email && Object.keys(errors.email).length > 0

        // console.log("userProfileDetailsRedux", userProfileDetailsRedux)
        const userProfileRedux = userProfileDetailsRedux && userProfileDetailsRedux.responseList && userProfileDetailsRedux.responseList[0]
        return (
            <>

                {
                    enabletoastify &&
                    <Toastify
                        autoClose={4000}
                        position={'top-right'}
                        theme={'light'}
                        status={'Success'}
                        msg={toastifyMsg}
                    />
                }

                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        // path={routes.containers.mediaPlan}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                        poc={true}
                    />
                }

                {<Modal open={openHelpModal}
                    onClose={() => { this.setState({ openHelpModal: !openHelpModal }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Contact us</h5>
                            <button type="button" onClick={() => { this.setState({ openHelpModal: !openHelpModal }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row form__style'>
                                <div className='col-md-12'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.name.key]}
                                        setting={formFields[formFields.name.key]}
                                        error={errors[formFields.name.key]}
                                        submited={submited}
                                        touched={touched[formFields.name.key]}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.email.key]}
                                        setting={formFields[formFields.email.key]}
                                        error={errors[formFields.email.key]}
                                        submited={submited}
                                        touched={touched[formFields.email.key]}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.contact.key]}
                                        setting={formFields[formFields.contact.key]}
                                        error={errors[formFields.contact.key]}
                                        submited={submited}
                                        touched={touched[formFields.contact.key]}
                                    />
                                </div>
                                <div className='col-md-12'>
                                    <Textarea
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.message.key]}
                                        setting={formFields[formFields.message.key]}
                                        error={errors[formFields.message.key]}
                                        submited={submited}
                                        touched={touched[formFields.message.key]}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openHelpModal: !openHelpModal }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" onClick={this.handleSubmit} className="btn btn-primary" data-dismiss="modal">Send</button>
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openUserProfile}
                    onClose={() => { this.setState({ openHelpModal: !openHelpModal }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">User Profile</h5>
                            <button type="button" onClick={() => { this.setState({ openUserProfile: !openUserProfile }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div class="container">
                                <div class="row align-items-center">
                                    {/* <!-- User Image Section --> */}
                                    <div class="col-md-3 justify-content-center d-flex">
                                        <div class="user-image text-center align-items-center d-flex justify-content-center border border-dotted rounded-3" style={{ position: "relative", width: "150px", height: "150px" }}>
                                            {base64Image ? <img src={base64Image} alt="User" style={{ maxWidth: '100%', width: "100%", height: "100%", objectFit: "cover", boxShadow: "0px 0px 10px 5px #9b9b9b33" }} />
                                                : <>
                                                    <>Choose an image to upload</>
                                                    {/* <i className='ti ti-photo ti-xl' /> */}
                                                </>
                                            } {/* Display the uploaded image */}

                                            {/* Hidden File Input */}
                                            <input
                                                type="file"
                                                accept="image/*"
                                                id="fileInput"
                                                className="form-control-file"
                                                style={{ display: 'none' }}
                                                onChange={this.handleImageChange}
                                            />
                                            {/* Button to Trigger File Input */}
                                            <button
                                                className="btn btn-primary rounded-circle"
                                                style={{ position: 'absolute', bottom: '-5px', right: '-7px', height: 33, width: 30, textAlign: "center", background: "#fff" }}
                                                onClick={() => this.triggerFileInput()}
                                                title="Change Image"
                                            >
                                                <i className="ti ti-pencil mr-0" style={{ fontSize: '18px' }} />
                                            </button>
                                        </div>
                                    </div>

                                    {/* User Info Section */}
                                    <div className="col-md-9 d-flex flex-column border rounded-3 pt-3">
                                        {/* User Name */}
                                        <div className="mb-3 d-flex justify-content-between align-items-center">
                                            <div>
                                                {editName ? (
                                                    // <Input
                                                    //     type="text"
                                                    //     value={userProfileDetails.name}
                                                    //     onChange={(e) => this.handleInputChange(e, "name")}
                                                    // />
                                                    <div className='row form__style'>
                                                        <div className='col-md-12 mb-n3 pt-1'>
                                                            <Input
                                                                onChange={(e) => this.handleInputChange(e, "name")}
                                                                onBlur={this.handleDetailsTouch}
                                                                value={userProfileDetails[userProfileFormFields.name.key]}
                                                                setting={userProfileFormFields[userProfileFormFields.name.key]}
                                                                error={errors[userProfileFormFields.name.key]}
                                                                submited={submited}
                                                                touched={touched[userProfileFormFields.name.key]}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <strong className="h5"><span style={{ fontWeight: "600" }}>Name :</span> &nbsp;{userProfileDetails && userProfileDetails.name}</strong>
                                                )}
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    disabled={isNameInvalid}
                                                    onClick={() => {
                                                        if (editName) {
                                                            this.handleUpdateProfile("editName");
                                                        } else {
                                                            this.handleEditToggle("editName");
                                                        }
                                                    }}
                                                >
                                                    <i style={{ fontSize: 18 }} className={editName ? 'ti ti-refresh' : 'ti ti-pencil'} />
                                                    {editName ? "Update" : "Edit"}
                                                </button>

                                                {editName &&
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ml-3"
                                                        onClick={() => {
                                                            this.handleEditToggle("editName");
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                }
                                            </div>
                                        </div>

                                        {/* User Email */}
                                        {!this.state.otpVisible && (
                                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                                <div>

                                                    {editEmail ? (
                                                        // <Input
                                                        //     type="text"
                                                        //     value={userProfileDetails.email}
                                                        //     onChange={(e) => this.handleInputChange(e, "email")}
                                                        // />
                                                        <div className='row form__style'>
                                                            <div className='col-md-12 mb-n3 pt-1'>
                                                                <Input
                                                                    onChange={(e) => this.handleInputChange(e, "email")}
                                                                    onBlur={this.handleDetailsTouch}
                                                                    value={userProfileDetails[userProfileFormFields.email.key]}
                                                                    setting={userProfileFormFields[userProfileFormFields.email.key]}
                                                                    error={errors[userProfileFormFields.email.key]}
                                                                    submited={submited}
                                                                    touched={touched[userProfileFormFields.email.key]}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <strong className="h5"><span style={{ fontWeight: "600" }}>Email :</span> &nbsp; {userProfileDetails && userProfileDetails.email}</strong>
                                                    )}
                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        disabled={isEmailInvalid}
                                                        onClick={() => {
                                                            if (editEmail) {
                                                                this.handleUpdateProfile("editEmail");
                                                            } else {
                                                                this.handleEditToggle("editEmail");
                                                            }
                                                        }}
                                                    >
                                                        <i style={{ fontSize: 18 }} className={editEmail ? 'ti ti-refresh' : 'ti ti-pencil'} />
                                                        {editEmail ? "Update" : "Edit"}
                                                    </button>

                                                    {editEmail &&
                                                        <button
                                                            className="btn btn-outline-primary btn-sm ml-3"
                                                            onClick={() => {
                                                                this.handleEditToggle("editEmail");
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        {this.state.otpVisible && (
                                            <div className='d-flex justify-content-between align-items-center'>
                                                {/* <input
                                                        type="text"
                                                        value={this.state.otp}
                                                        onChange={(e) => this.setState({ otp: e.target.value })}
                                                    /> */}
                                                <div className='row form__style'>
                                                    <div className='col-md-12 mb-n3 pt-1'>
                                                        {/* <label>Enter OTP:</label> */}
                                                        <Input
                                                            onChange={(e) => this.handleInputChange(e, "otp")}
                                                            onBlur={this.handleDetailsTouch}
                                                            value={userProfileDetails[userProfileFormFields.otp.key]}
                                                            setting={userProfileFormFields[userProfileFormFields.otp.key]}
                                                            error={errors[userProfileFormFields.otp.key]}
                                                            submited={submited}
                                                            touched={touched[userProfileFormFields.otp.key]}
                                                        />
                                                        <span className='pt-1'>Time Remaining: {this.formatTime(this.state.remainingTime)}</span> {/* Display the timer in MM:SS */}
                                                    </div>

                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        disabled={userProfileDetails ?
                                                            userProfileDetails[userProfileFormFields.otp.key] ?
                                                                userProfileDetails[userProfileFormFields.otp.key].toString().length == 6 ? false : true : true : true}
                                                        onClick={() => {
                                                            this.handleUpdateProfile("otp");
                                                        }}
                                                    >
                                                        Validate OTP
                                                    </button>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ml-3"
                                                        onClick={() => {
                                                            this.setState({ otpVisible: false });
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openUserProfile: !openUserProfile }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            {/* <button type="button" className="btn btn-primary" data-dismiss="modal">Send</button> */}
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openChangePassword}
                    onClose={() => { this.setState({ openChangePassword: !openChangePassword }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Change Password</h5>
                            <button type="button" onClick={() => { this.setState({ openChangePassword: !openChangePassword }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form id="formAuthentication" class="mb-3" onSubmit={this.handleResetSubmit}>
                                <div className='mb-3'>
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handlePasswordCTouch}
                                            value={changePasswordForm[changePasswordFormFields.oldPassword.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.oldPassword.key]}
                                            error={changePasswordErrors[changePasswordFormFields.oldPassword.key]}
                                            submited={changePasswordSubmited}
                                            touched={changePasswordTouched[changePasswordFormFields.oldPassword.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handleOldPassword} class={`ti ${changePasswordFormFields.oldPassword.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.oldPassword.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.oldPassword.key]} />
                                    }
                                </div>
                                <div class="mb-3 ">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handleTouch}
                                            value={changePasswordForm[changePasswordFormFields.password.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.password.key]}
                                            error={errors[changePasswordFormFields.password.key]}
                                            submited={submited}
                                            touched={touched[changePasswordFormFields.password.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handlePassword} class={`ti ${changePasswordFormFields.password.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.password.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.password.key]} />
                                    }
                                </div>
                                <div class="mb-3">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handleTouch}
                                            value={changePasswordForm[changePasswordFormFields.confirmPw.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.confirmPw.key]}
                                            error={errors[changePasswordFormFields.confirmPw.key]}
                                            submited={submited}
                                            touched={touched[changePasswordFormFields.confirmPw.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handleConfirmPassword} class={`ti ${changePasswordFormFields.confirmPw.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.confirmPw.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.confirmPw.key]} />
                                    }
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" disabled={this.changePasswordDisabled()} onClick={this.handleResetSubmit} data-dismiss="modal">Reset Password</button>
                            <button type="button" onClick={() => { this.setState({ openChangePassword: !openChangePassword }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openAccountAccess} size={this.state.accountAccessData.length > 25 ? "fullscreen" : "large"}
                    onClose={() => { this.setState({ openAccountAccess: !openAccountAccess }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Account Access</h5>
                            <button type="button" onClick={() => { this.setState({ openAccountAccess: !openAccountAccess }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div style={{ position: "relative" }}>
                                <button className={`btn ${displayMode == 'table' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleToTable}
                                    style={{
                                        borderRadius: '50%', width: '32px', height: '32px', padding: 0,
                                        position: "absolute",
                                        right: 70,
                                        top: 4,
                                        zIndex: 99
                                    }}>
                                    <i className='ti ti-table ti-sm mr-0'></i>
                                </button>
                                <button className={`btn ${displayMode == 'graph' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleToGraph}
                                    style={{
                                        borderRadius: '50%', width: '32px', height: '32px', padding: 0,
                                        position: "absolute",
                                        right: 20,
                                        top: 4,
                                        zIndex: 99
                                    }}>
                                    <i className='ti ti-hierarchy ti-sm mr-0'></i>
                                </button>
                            </div>
                            <>
                                {this.renderContent()}
                            </>
                        </div>
                        {/* <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openAccountAccess: !openAccountAccess }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" onClick={this.handleSubmit} className="btn btn-primary" data-dismiss="modal">Send</button>
                        </div> */}
                    </div>
                </Modal>}


                <nav
                    class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme pl-1"
                    id="layout-navbar"
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        left: 0,
                        flexWrap: 'nowrap'
                    }}
                >
                    <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3">
                        <a onClick={(e) => this.collapseToggle(e)} class="nav-item nav-link px-0 me-xl-4 d-xl-none" href="javascript:void(0)">
                            <i class="ti ti-menu-2 ti-sm"></i>
                        </a>
                    </div>

                    {/* <a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto text-decoration-none">
                        <i class="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
                        <i class="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
                    </a> */}

                    <div class="navbar-nav-right d-flex align-items-center justify-content-between" id="navbar-collapse">
                        {pathname.includes("atd-home") ? <h6 style={{ color: "#394256", fontSize: 20 }} className='mb-0'>Welcome <strong>{userProfileDetails && userProfileDetails.name}</strong>👋</h6>
                            :
                            <img src={logoImage} style={{ maxWidth: 80 }}></img>}
                        <ul class="navbar-nav flex-row align-items-center ms-auto">
                            <li className="nav-item tenantDropddown me-4 d-flex align-items-center">
                                <div className={`d-flex align-items-center tenant-switch ${preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList[0].tenantType && preSignInResponseList[0].tenantType != "Platform Manager" ? 'border border-left-0 rounded-pill' : ''}`}>
                                    {preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList[0].tenantType && preSignInResponseList[0].tenantType == "Platform Manager" &&
                                        <div style={{ margin: 10 }}>Account:</div>
                                    }
                                    <div>
                                        <TenantDropDown
                                            options={responseList.filter(item => isAgency ? item.tenantType == "Demo Agency" || item.tenantType == "DSP/Ad network" || item.tenantType == "Advertiser & DSP/Ad network" : !(item.tenantType == "Demo Agency" || item.tenantType == "DSP/Ad network" || item.tenantType == "Advertiser & DSP/Ad network"))}
                                            onChange={this.handleTenantChange}
                                            tenantId={tenantId}
                                        />
                                    </div>
                                    {preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList[0].tenantType && preSignInResponseList[0].tenantType != "Platform Manager" &&
                                        <Switch
                                            checked={isAgency}
                                            onChange={this.handleToggle}
                                            checkedChildren={<span style={{ color: 'white', fontWeight: 600 }}>Agency</span>} // Change color for on state
                                            unCheckedChildren={<span style={{ color: 'white', fontWeight: 600 }}>Advertiser</span>} // Change color for off state
                                            className="agency-switch small-switch mx-2" // Apply custom class for styling
                                        />
                                    }
                                </div>
                            </li>
                            <li class="nav-item navbar-dropdown dropdown-user dropdown">
                                <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                                    <div class="avatar avatar-online">
                                        {
                                            userProfileRedux && userProfileRedux.profilePic ?
                                                <img style={{ width: '100%', height: '100%' }} className="img-fluid rounded-circle" src={base64Image} alt="profile" />
                                                :
                                                <i class="ti ti-user-circle ti-lg" ></i>
                                        }
                                    </div>
                                </a>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a class="dropdown-item avatar-adj" style={{ cursor: 'pointer' }} onClick={() => this.setState({ openUserProfile: true }, () => {
                                            // this.userProfileDetails()
                                        })}>
                                            <div class="avatar avatar-online avatar-dropdown">
                                                <i class="ti ti-user-circle me-2 ti-sm" ></i>
                                            </div>
                                            {/* <span class="align-middle">{username}</span> */}
                                            <span class="align-middle">User Profile</span>

                                        </a>
                                    </li>
                                    <li>
                                        <div class="dropdown-divider"></div>
                                    </li>
                                    <li>
                                        <a class="dropdown-item avatar-adj" href="#" onClick={() => this.handleAccountAccess()}>
                                            <i class="ti ti-file-settings ti-sm" ></i>
                                            <span class="align-middle">Accounts & Access</span>

                                        </a>
                                    </li>
                                    <li>
                                        <div class="dropdown-divider"></div>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#" onClick={() => { this.setForm() }} >
                                            <i class="ti ti-help me-2 ti-sm"></i>
                                            <span class="align-middle">Help</span>
                                        </a>
                                    </li>
                                    <li>
                                        <div class="dropdown-divider"></div>
                                    </li>
                                    <li>
                                        <a class="dropdown-item avatar-adj" style={{ cursor: 'pointer' }} onClick={() => this.changePasswordAction()}>
                                            <i className="ti ti-square-asterisk me-2 ti-sm" ></i>
                                            <span class="align-middle">Change Password</span>

                                        </a>
                                    </li>
                                    <li>
                                        <div class="dropdown-divider"></div>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#" onClick={this.handleLogout} >
                                            <i class="ti ti-logout me-2 ti-sm"></i>
                                            <span class="align-middle">Log Out</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        preSignInState: get(state, 'app.preSignInState', {}),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        preSignInResponseList: get(state, 'app.preSignInData.responseList', []),
        platformConfiguration: get(state, 'app.platformConfiguration', ''),
        userProfileDetailsRedux: get(state, 'app.userProfileDetails', {}),
        userId: get(state, "app.preSignInData.userId", ""),
        authToken: get(state, "app.signInData.authToken", ""),
    }),
    {
        getReSignInDataAction,
        logoutAction,
        dispatchPreSignInData,
        getAddUnitListAction,
        supportAction,
        getUserProfileDetailsAction,
        postUserProfileDetailsAction,
        getTenantAccountAccessAction,
        getDefaultPageAccess,
    }
)(Header));
